module.exports = __webpack_public_path__ + "static/media/rv.eb0c3e71.svg";